function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAssociation = function SvgAssociation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Group_168",
    width: 24,
    height: 24,
    "data-name": "Group 168",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_29",
    d: "M0 0h24v24H0z",
    "data-name": "Path 29",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_30",
    d: "M3.6 4.6v11.2h12.8V4.6zM2.8 3h14.4a.8.8 0 0 1 .8.8v12.8a.8.8 0 0 1-.8.8H2.8a.8.8 0 0 1-.8-.8V3.8a.8.8 0 0 1 .8-.8zm9.6 3.2l2.8 2.4-2.8 2.4V9.4H9.2V7.8h3.2zm-4.8 8l-2.8-2.4 2.8-2.4V11h3.2v1.6H7.6z",
    "data-name": "Path 30",
    transform: "translate(2 2)",
    style: {
      fill: "#32325d"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssociation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/association.c2728008.svg";
export { ForwardRef as ReactComponent };